import { render, staticRenderFns } from "./TitlesHero.vue?vue&type=template&id=0736bec6&scoped=true"
import script from "./TitlesHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitlesHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitlesHero.vue?vue&type=style&index=0&id=0736bec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736bec6",
  null
  
)

export default component.exports